import { render, staticRenderFns } from "./ListTurnoAjustes.vue?vue&type=template&id=7c887438&"
import script from "./ListTurnoAjustes.vue?vue&type=script&lang=js&"
export * from "./ListTurnoAjustes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports